import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { wirelessOrderForm, orderStatus } from '../../utils/constant';
import { apiHost, config } from '../../utils/request';
import { Button } from './css';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const incorrectReasonForSubmissionVariants = [
  EN.WLS.WIRELESS_ORDER_DETAILS.actions.incorrectReasonForSubmission,
  FR.WLS.WIRELESS_ORDER_DETAILS.actions.incorrectReasonForSubmission
];

const Continue = ({ orderData }) => {
  const { step = 1, status, flag } = orderData;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, continueLabel, modifyLabel },
    formButtons: { confirmButtonLabel }
  } = localizedStrings;
  const {
    locale,
    categoryName,
    id,
    isQuoteReference,
    reasonForSubmission
  } = orderData;
  const history = useHistory();

  const handleModifyQuote = async () => {
    let stepToNavigateTo = step;
    if (
      status === orderStatus.waitingOnSales &&
      step === 1 &&
      incorrectReasonForSubmissionVariants.includes(reasonForSubmission)
    ) {
      await axios.put(
        `${apiHost}/orders/${id}/reset-meta`,
        {
          meta: {
            step: 1,
            locale,
            categoryName,
            id,
            isQuoteReference,
            reasonForSubmission,
            flag
          }
        },
        config()
      );
    }
    if (step > 3) {
      stepToNavigateTo = step - 1;
    }
    history.push({
      pathname: `/${locale}/${categoryName}/${wirelessOrderForm}`,
      search: `?orderId=${id}&step=${stepToNavigateTo}&isEditing=true`
    });
    window.location.reload();
  };

  let buttonLabel;
  if (
    status === orderStatus.waitingOnSales ||
    status === orderStatus.canceled ||
    status === orderStatus.canceledBySalesRep
  ) {
    buttonLabel = modifyLabel;
  } else {
    buttonLabel = continueLabel;
  }

  if (isQuoteReference) return null;

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>{buttonLabel}</Button>
      <Modal
        heading={confirmationDialog}
        bodyText="Are you sure you want to continue with the order"
        confirmCTAText={confirmButtonLabel}
        // cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleModifyQuote()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

Continue.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default Continue;
